export const currencies = {
  AED: { symbol: "د.إ", name: "United Arab Emirates Dirham" },
  AFN: { symbol: "Afs", name: "Afghan Afghani" },
  ALL: { symbol: "L", name: "Albanian Lek" },
  AMD: { symbol: "֏", name: "Armenian Dram" },
  ANG: { symbol: "ƒ", name: "Netherlands Antillean Guilder" },
  AOA: { symbol: "Kz", name: "Angolan Kwanza" },
  ARS: { symbol: "$", name: "Argentine Peso" },
  AUD: { symbol: "A$", name: "Australian Dollar" },
  AWG: { symbol: "ƒ", name: "Aruban Florin" },
  AZN: { symbol: "₼", name: "Azerbaijani Manat" },
  BAM: { symbol: "KM", name: "Bosnia-Herzegovina Convertible Mark" },
  BBD: { symbol: "Bds$", name: "Barbadian Dollar" },
  BDT: { symbol: "৳", name: "Bangladeshi Taka" },
  BGN: { symbol: "лв", name: "Bulgarian Lev" },
  BHD: { symbol: ".د.ب", name: "Bahraini Dinar" },
  BIF: { symbol: "FBu", name: "Burundian Franc" },
  BMD: { symbol: "BD$", name: "Bermudian Dollar" },
  BND: { symbol: "B$", name: "Brunei Dollar" },
  BOB: { symbol: "Bs.", name: "Bolivian Boliviano" },
  BRL: { symbol: "R$", name: "Brazilian Real" },
  BSD: { symbol: "B$", name: "Bahamian Dollar" },
  BTN: { symbol: "Nu.", name: "Bhutanese Ngultrum" },
  BWP: { symbol: "P", name: "Botswana Pula" },
  BYN: { symbol: "Br", name: "Belarusian Ruble" },
  BZD: { symbol: "BZ$", name: "Belize Dollar" },
  CAD: { symbol: "C$", name: "Canadian Dollar" },
  CDF: { symbol: "FC", name: "Congolese Franc" },
  CHF: { symbol: "CHF", name: "Swiss Franc" },
  CLP: { symbol: "$", name: "Chilean Peso" },
  CNY: { symbol: "¥", name: "Chinese Yuan" },
  COP: { symbol: "$", name: "Colombian Peso" },
  CRC: { symbol: "₡", name: "Costa Rican Colón" },
  CUC: { symbol: "$", name: "Cuban Convertible Peso" },
  CUP: { symbol: "₱", name: "Cuban Peso" },
  CVE: { symbol: "Esc", name: "Cape Verdean Escudo" },
  CZK: { symbol: "Kč", name: "Czech Koruna" },
  DJF: { symbol: "Fdj", name: "Djiboutian Franc" },
  DKK: { symbol: "kr", name: "Danish Krone" },
  DOP: { symbol: "RD$", name: "Dominican Peso" },
  DZD: { symbol: "دج", name: "Algerian Dinar" },
  EGP: { symbol: "£", name: "Egyptian Pound" },
  ERN: { symbol: "Nfa", name: "Eritrean Nakfa" },
  ETB: { symbol: "Br", name: "Ethiopian Birr" },
  EUR: { symbol: "€", name: "Euro" },
  FJD: { symbol: "FJ$", name: "Fijian Dollar" },
  FKP: { symbol: "£", name: "Falkland Islands Pound" },
  GBP: { symbol: "£", name: "British Pound Sterling" },
  GEL: { symbol: "₾", name: "Georgian Lari" },
  GHS: { symbol: "₵", name: "Ghanaian Cedi" },
  GIP: { symbol: "£", name: "Gibraltar Pound" },
  GMD: { symbol: "D", name: "Gambian Dalasi" },
  GNF: { symbol: "FG", name: "Guinean Franc" },
  GTQ: { symbol: "Q", name: "Guatemalan Quetzal" },
  GYD: { symbol: "G$", name: "Guyanese Dollar" },
  HKD: { symbol: "HK$", name: "Hong Kong Dollar" },
  HNL: { symbol: "L", name: "Honduran Lempira" },
  HRK: { symbol: "kn", name: "Croatian Kuna" },
  HTG: { symbol: "G", name: "Haitian Gourde" },
  HUF: { symbol: "Ft", name: "Hungarian Forint" },
  IDR: { symbol: "Rp", name: "Indonesian Rupiah" },
  ILS: { symbol: "₪", name: "Israeli New Shekel" },
  INR: { symbol: "₹", name: "Indian Rupee" },
  IQD: { symbol: "ع.د", name: "Iraqi Dinar" },
  IRR: { symbol: "﷼", name: "Iranian Rial" },
  ISK: { symbol: "kr", name: "Icelandic Króna" },
  JMD: { symbol: "J$", name: "Jamaican Dollar" },
  JOD: { symbol: "JD", name: "Jordanian Dinar" },
  JPY: { symbol: "¥", name: "Japanese Yen" },
  KES: { symbol: "KSh", name: "Kenyan Shilling" },
  KGS: { symbol: "лв", name: "Kyrgyzstani Som" },
  KHR: { symbol: "៛", name: "Cambodian Riel" },
  KMF: { symbol: "CF", name: "Comorian Franc" },
  KPW: { symbol: "₩", name: "North Korean Won" },
  KRW: { symbol: "₩", name: "South Korean Won" },
  KWD: { symbol: "KD", name: "Kuwaiti Dinar" },
  KYD: { symbol: "KY$", name: "Cayman Islands Dollar" },
  KZT: { symbol: "₸", name: "Kazakhstani Tenge" },
  LAK: { symbol: "₭", name: "Lao Kip" },
  LBP: { symbol: "£", name: "Lebanese Pound" },
  LKR: { symbol: "Rs", name: "Sri Lankan Rupee" },
  LRD: { symbol: "L$", name: "Liberian Dollar" },
  LSL: { symbol: "M", name: "Lesotho Loti" },
  LYD: { symbol: "ل.د", name: "Libyan Dinar" },
  MAD: { symbol: "د.م.", name: "Moroccan Dirham" },
  MDL: { symbol: "L", name: "Moldovan Leu" },
  MGA: { symbol: "Ar", name: "Malagasy Ariary" },
  MKD: { symbol: "ден", name: "Macedonian Denar" },
  MMK: { symbol: "K", name: "Myanma Kyat" },
  MNT: { symbol: "₮", name: "Mongolian Tugrik" },
  MOP: { symbol: "P", name: "Macanese Pataca" },
  MRU: { symbol: "UM", name: "Mauritanian Ouguiya" },
  MUR: { symbol: "Rs", name: "Mauritian Rupee" },
  MVR: { symbol: "Rf", name: "Maldivian Rufiyaa" },
  MWK: { symbol: "MK", name: "Malawian Kwacha" },
  MXN: { symbol: "$", name: "Mexican Peso" },
  MYR: { symbol: "RM", name: "Malaysian Ringgit" },
  MZN: { symbol: "MT", name: "Mozambican Metical" },
  NAD: { symbol: "N$", name: "Namibian Dollar" },
  NGN: { symbol: "₦", name: "Nigerian Naira" },
  NIO: { symbol: "C$", name: "Nicaraguan Córdoba" },
  NOK: { symbol: "kr", name: "Norwegian Krone" },
  NPR: { symbol: "Rs", name: "Nepalese Rupee" },
  NZD: { symbol: "NZ$", name: "New Zealand Dollar" },
  OMR: { symbol: "ر.ع.", name: "Omani Rial" },
  PAB: { symbol: "B./", name: "Panamanian Balboa" },
  PEN: { symbol: "S/", name: "Peruvian Sol" },
  PGK: { symbol: "K", name: "Papua New Guinean Kina" },
  PHP: { symbol: "₱", name: "Philippine Peso" },
  PKR: { symbol: "₨", name: "Pakistani Rupee" },
  PLN: { symbol: "zł", name: "Polish Zloty" },
  PYG: { symbol: "₲", name: "Paraguayan Guarani" },
  QAR: { symbol: "ر.ق", name: "Qatari Riyal" },
  RON: { symbol: "lei", name: "Romanian Leu" },
  RSD: { symbol: "дин", name: "Serbian Dinar" },
  RUB: { symbol: "₽", name: "Russian Ruble" },
  RWF: { symbol: "FRw", name: "Rwandan Franc" },
  SAR: { symbol: "﷼", name: "Saudi Riyal" },
  SBD: { symbol: "SI$", name: "Solomon Islands Dollar" },
  SCR: { symbol: "SR", name: "Seychellois Rupee" },
  SDG: { symbol: "£", name: "Sudanese Pound" },
  SEK: { symbol: "kr", name: "Swedish Krona" },
  SGD: { symbol: "S$", name: "Singapore Dollar" },
  SHP: { symbol: "£", name: "Saint Helena Pound" },
  SLL: { symbol: "Le", name: "Sierra Leonean Leone" },
  SOS: { symbol: "S", name: "Somali Shilling" },
  SRD: { symbol: "$", name: "Surinamese Dollar" },
  STN: { symbol: "Db", name: "São Tomé and Príncipe Dobra" },
  SYP: { symbol: "£", name: "Syrian Pound" },
  SZL: { symbol: "E", name: "Swazi Lilangeni" },
  THB: { symbol: "฿", name: "Thai Baht" },
  TJS: { symbol: "ЅМ", name: "Tajikistani Somoni" },
  TMT: { symbol: "m", name: "Turkmenistani Manat" },
  TND: { symbol: "د.ت", name: "Tunisian Dinar" },
  TOP: { symbol: "T$", name: "Tongan Paʻanga" },
  TRY: { symbol: "₺", name: "Turkish Lira" },
  TTD: { symbol: "TT$", name: "Trinidad and Tobago Dollar" },
  TWD: { symbol: "NT$", name: "New Taiwan Dollar" },
  TZS: { symbol: "TZS", name: "Tanzanian Shilling" },
  UAH: { symbol: "₴", name: "Ukrainian Hryvnia" },
  UGX: { symbol: "USh", name: "Ugandan Shilling" },
  USD: { symbol: "$", name: "United States Dollar" },
  UYU: { symbol: "$U", name: "Uruguayan Peso" },
  UZS: { symbol: "so'm", name: "Uzbekistani Som" },
  VES: { symbol: "Bs.", name: "Venezuelan Bolívar Soberano" },
  VND: { symbol: "₫", name: "Vietnamese Dong" },
  VUV: { symbol: "VT", name: "Vanuatu Vatu" },
  WST: { symbol: "WS$", name: "Samoan Tala" },
  XAF: { symbol: "FCFA", name: "Central African CFA Franc" },
  XCD: { symbol: "EC$", name: "East Caribbean Dollar" },
  XOF: { symbol: "CFA", name: "West African CFA franc" },
  XPF: { symbol: "₣", name: "CFP Franc" },
  YER: { symbol: "﷼", name: "Yemeni Rial" },
  ZAR: { symbol: "R", name: "South African Rand" },
  ZMW: { symbol: "ZK", name: "Zambian Kwacha" },
  ZWL: { symbol: "Z$", name: "Zimbabwean Dollar" },
};
